import RICH_TEXT_TYPES from "../constants/richTextTypes";

export const getVideoDataInPage = (content) => {
  return content?.find((item) => item._type === RICH_TEXT_TYPES.videoEmbed);
};
